<template>
  <div class="team-work-section">
    <el-row>
      <el-col :xs="24" :lg="6">
        <div class="team-work-section-title">
          <span>{{ $t('text.team_support') }}</span>
        </div>
      </el-col>
      <el-col :xs="24" :lg="18">
        <div class="ml-5 p-10" v-if="improvements.length > 0">
          <div>{{ $t('text.a_few_things_to_improve_on') }}.</div>
        </div>
      </el-col>
    </el-row>
    <div class="team-work-section-content" v-loading="loading">
      <div
        v-if="totalPadCycles < requiredPadCycles"
        class="text-center mt-25 mb-25 yellow-font"
      >
        <i class="el-icon-warning mr-5" style="font-size: 20px;"></i>
        <span>{{
          $t('text.insufficient_data_warning', {
            count: requiredPadCycles - totalPadCycles
          })
        }}</span>
      </div>
      <el-row v-else>
        <el-col :xs="24" :lg="6">
          <div class="mb-10">
            {{ $t('text.overall_evaluation') }}
          </div>
          <el-rate v-model="overallScore" disabled> </el-rate>
          <div class="mt-10">
            {{ getRandomSummary }}
          </div>
        </el-col>
        <el-col :xs="24" :lg="18">
          <el-row :gutter="15">
            <el-col
              v-for="(item, index) in improvements"
              :key="'improve-items' + index"
              class="improve-item"
              :xs="24"
              :lg="8"
              :md="12"
              style="height: auto;"
            >
              <div class="improve-item-content">
                <div class="improve-number v-h-center">{{ index + 1 }}</div>
                <el-popover
                  width="230"
                  popper-class="offline-nodes-popover"
                  :disabled="item !== 'NODE_OFFLINE'"
                  trigger="click"
                >
                  <el-table :data="offlineNodes" size="mini" max-height="120px">
                    <el-table-column
                      width="130px"
                      prop="MacAddress"
                      :label="$t('text.mac_address')"
                    ></el-table-column>
                    <el-table-column
                      prop="Location"
                      :label="$t('text.location')"
                    ></el-table-column>
                  </el-table>
                  <div
                    class="improve-item-img-wrapper v-h-center"
                    :class="getImproveInfo(item).class"
                    slot="reference"
                  >
                    <img
                      :src="
                        require('@/assets/image/NotificationIcons/' +
                          getImproveInfo(item).img)
                      "
                      :class="getImproveInfo(item).imgClass"
                      :key="Math.random()"
                    />
                  </div>
                </el-popover>
                <div
                  class="improve-item-text"
                  :class="{ 'auto-scroll': isScrollable[index] }"
                >
                  <p :ref="`text-${index}`">{{ getImproveInfo(item).text }}</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    overallScore: {
      require: true,
      type: Number
    },
    improvements: {
      require: true,
      type: Array
    },
    nodes: {
      require: true,
      type: Array
    },
    requiredPadCycles: {
      require: true,
      type: Number
    },
    totalPadCycles: {
      require: true,
      type: Number
    },
    loading: {
      require: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      summary: [
        [
          this.$t('text.team_support_desc1'),
          this.$t('text.team_support_desc2'),
          this.$t('text.team_support_desc3'),
          this.$t('text.team_support_desc4')
        ],
        [
          this.$t('text.team_support_desc5'),
          this.$t('text.team_support_desc6'),
          this.$t('text.team_support_desc7')
        ],
        [
          this.$t('text.team_support_desc8'),
          this.$t('text.team_support_desc9'),
          this.$t('text.team_support_desc10')
        ],
        [
          this.$t('text.team_support_desc11'),
          this.$t('text.team_support_desc12'),
          this.$t('text.team_support_desc13'),
          this.$t('text.team_support_desc14'),
          this.$t('text.team_support_desc15')
        ]
      ],
      isScrollable: []
    }
  },
  computed: {
    getImproveInfo() {
      return type => {
        let info = {
          img: '',
          text: ''
        }
        switch (type) {
          case 'EARLY_CHANGE':
            info = {
              img: 'simple-pad.png',
              text: this.$t('text.improve_early_change_desc', {
                pad: this.$store.state.locale.pad
              }),
              imgClass: 'w-30',
              class: 'type2'
            }
            break
          case 'CHANGE_RESPONSE_TIME':
            info = {
              img: 'simple-pad.png',
              text: this.$t('text.improve_change_response_time_desc', {
                pads: this.$firstLetterCapitalize(this.$store.state.locale.pads)
              }),
              imgClass: 'w-30',
              class: 'type2'
            }
            break
          case 'GOAL_RESPONSE_TIME':
            info = {
              img: 'simple-pad.png',
              text: this.$t('text.improve_goal_response_time_desc', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              imgClass: 'w-30',
              class: 'type2'
            }
            break
          case 'INCORRECT_CLIPPING':
            info = {
              img: 'pod-unclipped.png',
              text: this.$t('text.improve_incorrect_clipping_desc', {
                pad: this.$store.state.locale.pad
              }),
              imgClass: 'w-30 mb-3',
              class: 'type1'
            }
            break
          case 'BATTERY_CHANGE':
            info = {
              img: 'simple-replace-battery.png',
              text: this.$t('text.improve_battery_change_desc'),
              imgClass: 'w-30',
              class: 'type1'
            }
            break
          case 'LEAKAGE':
            info = {
              img: 'simple-pad-gray.png',
              text: this.$t('text.improve_leakage_desc', {
                pad: this.$store.state.locale.pad
              }),
              imgClass: 'w-30',
              class: 'type3'
            }
            break
          case 'FREQUENT_LOST_CONNECTION':
            info = {
              img: 'simple-lost-connection.png',
              text: this.$t('text.improve_frequent_lost_connection_desc', {
                pad: this.$store.state.locale.pad,
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              imgClass: 'w-30',
              class: 'type1'
            }
            break
          case 'NODE_OFFLINE':
            info = {
              img: 'simple-lost-connection.png',
              text: this.$t('text.improve_offline_nodes_desc'),
              imgClass: 'w-30',
              class: 'type1'
            }
            break
          default:
            info = {
              img: 'simple-lost-connection.png',
              text: this.$t('text.improve_frequent_lost_connection_desc', {
                pad: this.$store.state.locale.pad,
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              imgClass: 'w-30',
              class: 'type1'
            }
        }
        return info
      }
    },
    getRandomSummary() {
      let index = Math.floor(this.overallScore)
      if (Number.isInteger(this.overallScore)) {
        index = index - 1
      }
      if (index < 0) index = 0
      if (index > this.summary.length - 1) index = this.summary.length - 1

      let summaryList = []
      if (this.overallScore <= 2) {
        summaryList = this.summary[0]
      } else if (this.overallScore > 2 && this.overallScore <= 3) {
        summaryList = this.summary[1]
      } else if (this.overallScore > 3 && this.overallScore <= 4) {
        summaryList = this.summary[2]
      } else {
        summaryList = this.summary[3]
      }

      const randomIndex = Math.floor(Math.random() * summaryList.length)
      return summaryList[randomIndex]
    },
    offlineNodes() {
      return this.nodes.filter(item => {
        return item.Status.toLowerCase() === 'offline'
      })
    }
  },
  mounted() {
    this.checkScrollableTexts()
  },
  watch: {
    improvements() {
      this.checkScrollableTexts()
    }
  },
  methods: {
    // we would like to cap it at three lines and it scrolls slowly upwards to show the whole text
    checkScrollableTexts() {
      this.$nextTick(() => {
        this.isScrollable = this.improvements.map((_, index) => {
          const textElement = this.$refs[`text-${index}`][0]
          const maxHeight = 72
          return textElement.scrollHeight > maxHeight
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
